import { Observable } from 'rxjs';
import { Channel, ChannelType } from '../models';

/**
 * Abstract class to be implemented by any service that provide channels.
 *
 * @export
 */
export abstract class ChannelsService {
    /**
     * Provides an observable will all available channels for the current tenant.
     */
    abstract channels(): Observable<Channel[]>;

    /**
     * Provides a comparison between channel types lists received as arguments.
     */
    abstract validateChannelTypes(
        channelTypesListDestiny: ChannelType[],
        channelTypesListSource?: ChannelType[],
        excludeItems?: ChannelType[]
    ): boolean;
}
